import { AbstractControl } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

interface EmailOk {
  ok: any;
  [key: string]: any;
}

interface Service {
  checkEmail(email: string, ignoreAccountExists: boolean): Observable<EmailOk>;
}

export class ValidateEmail {
  static create(
    service: Service,
    debounceTime: number,
    ignoreAccountExists: boolean
  ) {
    return (control: AbstractControl) => {
      return timer(debounceTime).pipe(
        switchMap(() => {
          return service.checkEmail(control.value, ignoreAccountExists).pipe(
            map((res) => null),
            catchError((resp) => {
              if (!resp) return of(null);
              if (resp.error && resp.error.errors) {
                const obj = {
                  emailTaken: false,
                  contractorEmail: false,
                  ygreneEmail: false,
                  yopMail: false,
                };
                const error = resp.error.errors[0];
                const pattern1 = new RegExp(/^Email already exist/);
                const pattern2 = new RegExp(/^Contractor email/i);
                const pattern3 = new RegExp(/^Ygrene email/i);
                const pattern4 = new RegExp(/^Yopmail email/i);
                if (pattern1.test(error.message)) obj.emailTaken = true;
                if (pattern2.test(error.message)) obj.contractorEmail = true;
                if (pattern3.test(error.message)) obj.ygreneEmail = true;
                if (pattern4.test(error.message)) obj.yopMail = true;
                return of(obj);
              }
              return of(null);
            })
          );
        })
      );
    };
  }
}
